import React from "react";
import { ClipboardList, PackageCheck, Truck } from "lucide-react";

const steps = [
  {
    n: "01",
    icon: ClipboardList,
    title: "Antrag stellen",
    description:
      "Formular online ausfüllen – wir kümmern uns um die Beantragung bei Ihrer Pflegekasse.",
  },
  {
    n: "02",
    icon: PackageCheck,
    title: "Box zusammenstellen",
    description:
      "Wählen Sie Ihre Wunschprodukte aus – flexibel, individuell, jeden Monat neu kombinierbar.",
  },
  {
    n: "03",
    icon: Truck,
    title: "Monatlich erhalten",
    description:
      "Diskreter Versand direkt zu Ihnen nach Hause – bequem, pünktlich und kostenfrei.",
  },
];

export const Ablauf = () => {
  return (
    <section
      id="ablauf"
      data-testid="ablauf-section"
      className="relative py-24 sm:py-32 bg-[#FAFAF7]"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <div className="max-w-3xl mb-16">
          <div className="text-xs font-semibold uppercase tracking-[0.25em] text-[#3FA66D] mb-5">
            So funktioniert's
          </div>
          <h2
            data-testid="ablauf-headline"
            className="text-4xl sm:text-5xl font-medium leading-tight text-[#1A1A1F]"
          >
            <span className="text-gradient-dark">In drei Schritten</span>{" "}
            <span className="text-gradient-green">zur Pflegebox.</span>
          </h2>
        </div>

        <div className="relative">
          <div className="hidden md:block absolute top-12 left-[12%] right-[12%] dashed-line" />

          <div className="grid md:grid-cols-3 gap-6">
            {steps.map(({ n, icon: Icon, title, description }) => (
              <div
                key={n}
                data-testid={`ablauf-step-${n}`}
                className="relative rounded-3xl bg-white border border-[#1A1A1F]/[0.06] p-8 hover:border-[#3FA66D]/30 hover:shadow-[0_18px_40px_-20px_rgba(63,166,109,0.25)] transition-all"
              >
                <div className="flex items-center justify-between mb-8">
                  <div className="text-xs font-semibold tracking-[0.3em] text-[#5A5F66]/70">
                    Schritt {n}
                  </div>
                  <div className="inline-flex items-center justify-center h-12 w-12 rounded-2xl bg-[#3FA66D]/12 border border-[#3FA66D]/40">
                    <Icon size={20} className="text-[#3FA66D]" />
                  </div>
                </div>
                <h3 className="text-2xl font-medium text-[#1A1A1F]">{title}</h3>
                <p className="mt-3 text-sm text-[#5A5F66] leading-relaxed">
                  {description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Ablauf;
